<template>
    <div class="joins">
        <div class="container">
            <h2>{{join.title}}</h2>
            <p>{{join.content}}</p>
            <button>Order Now</button>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            join :Object
        }
    }
</script>

<style scoped>
    .joins{
        background-color: #2b2b2b;
        text-align: center;
        color: #ffff;
        padding: 50px 0;
    }
    .joins h2{
        font-weight: 500;
    }
    .joins p{
        font-size: .8rem;
        color: #a4a4a4;
        padding: 15px 0;
        width: 20rem;
        margin: auto;
    }
    .joins button{
        background-color: unset;
        border: 3px solid #FFD60A;
        border-radius: 50px;
        padding: 5px 10px;
        color: #FFD60A;
    }

    /* Large Desktop */
    @media(min-width: 1200px){

    }
    /* Middle Desktop */
    @media(min-width: 1025px) and (max-width: 1199px){

    }
    /* Desktop */
    @media(min-width: 992px) and (max-width: 1024px){
        
    }
    /* Tablet */
    @media(min-width: 768px) and (max-width: 991px){
       
    }
    /* Handphone */
    @media(max-width: 767px){
        
    }
</style>